<template>
  <div class="w-full">
    <form class="bg-white px-8 pt-6 pb-8 mb-4" @submit.prevent="updateImm">
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="name">Name</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="name"
          type="text"
          v-model="imm.name"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="faktor post">Ausg</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="ausg"
          type="text"
          v-model="imm.ausg"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="zup mosina">Kf</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="kf"
          type="text"
          v-model="imm.kf"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="letzte meile">I %</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="ap1"
          type="text"
          v-model="imm.ap1"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="paushall">II %</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="ap2"
          type="text"
          v-model="imm.ap2"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="thc zup">III %</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="ap3"
          type="text"
          v-model="imm.ap3"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="thc zup">Db1</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="db1"
          type="text"
          v-model="imm.db1"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="thc zup">Kvar</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="kvar"
          type="text"
          v-model="imm.kvar"
        />
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="thc zup">Fakt</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="fakt"
          type="text"
          v-model="imm.fakt"
        />
      </div>

      <div class="flex items-center justify-between">
        <button
          class="bg-teal-400 hover:bg-white hover:text-teal-400 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >Update</button>
        <router-link
          to="/fd-imm-table"
          class="inline-block align-baseline font-semibold text-sm text-teal-400 hover:text-teal-300"
        >Back</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      imm: {},
      id: this.$route.params.id
    };
  },
  created() {
    this.getImm();
  },
  methods: {
    getImm() {
      axios
        .get(`${process.env.VUE_APP_API}/calculate/imm/${this.id}`)
        .then(response => {
          // console.log(response);
          this.imm = response.data;
        });
    },
    updateImm() {
      axios
        .put(`${process.env.VUE_APP_API}/calculate/imm/${this.id}`, {
          name: this.imm.name,
          ausg: this.imm.ausg,
          kf: this.imm.kf,
          ap1: this.imm.ap1,
          ap2: this.imm.ap2,
          ap3: this.imm.ap3,
          db1: this.imm.db1,
          kvar: this.imm.kvar,
          fakt: this.imm.fakt
        })
        .then(this.$router.push("/fd-imm"));
    }
  }
};
</script>

<style>
</style>